export const ZOOM_LEVEL_VALUE_AUTO: number = -1

// Bit flag used to indicate that the corresponding chart type supports multiple data series plot points on the y-axis.
export const CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES: number = 0x01000000

export const CHART_STYLE_OPTION_VALUE_PIE_2D: number = 0
export const CHART_STYLE_OPTION_VALUE_PIE_3D: number = 5
export const CHART_STYLE_OPTION_VALUE_DOUGHNUT_2D: number = 10
export const CHART_STYLE_OPTION_VALUE_DOUGHNUT_3D: number = 15
export const CHART_STYLE_OPTION_VALUE_LINE: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 20
export const CHART_STYLE_OPTION_VALUE_AREA: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 30
export const CHART_STYLE_OPTION_VALUE_AREA_STACKED: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 31
export const CHART_STYLE_OPTION_VALUE_RADAR_POLAR_AREA: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 40
export const CHART_STYLE_OPTION_VALUE_COLUMN_2D: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 50
export const CHART_STYLE_OPTION_VALUE_COLUMN_2D_STACKED: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 51
export const CHART_STYLE_OPTION_VALUE_COLUMN_3D: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 55
export const CHART_STYLE_OPTION_VALUE_COLUMN_3D_STACKED: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 56
export const CHART_STYLE_OPTION_VALUE_BAR_2D: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 60
export const CHART_STYLE_OPTION_VALUE_BAR_2D_STACKED: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 61
export const CHART_STYLE_OPTION_VALUE_BAR_3D: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 65
export const CHART_STYLE_OPTION_VALUE_BAR_3D_STACKED: number = CHART_STYLE_MASK_CAPABILITIES_MULTIPLEDATASERIES | 66

export const CHART_PROVIDER_OPTION_VALUE_HIGH_CHARTS: number = 1
export const CHART_PROVIDER_OPTION_VALUE_AM_CHARTS: number = 2

// Total Call By Interval
export const REPORT_CALLS_BY_INTERVAL_15_MINUTES_VALUE: number = 15
export const REPORT_CALLS_BY_INTERVAL_30_MINUTES_VALUE: number = 30
export const REPORT_CALLS_BY_INTERVAL_60_MINUTES_VALUE: number = 1
export const REPORT_CALLS_BY_INTERVAL_120_MINUTES_VALUE: number = 2

// Call By Interval Hours
export const REPORT_CALLS_BY_INTERVAL_1_HOUR_VALUE: number = 1
export const REPORT_CALLS_BY_INTERVAL_2_HOUR_VALUE: number = 2
export const REPORT_CALLS_BY_INTERVAL_4_HOUR_VALUE: number = 4
export const REPORT_CALLS_BY_INTERVAL_8_HOUR_VALUE: number = 8
export const REPORT_CALLS_BY_INTERVAL_12_HOUR_VALUE: number = 12

export const REPORT_CALLS_BY_ONE: number = 1

// Call By Interval Type
export enum CallIntervalTypes {
    NONE = 0,
    MINUTES = 1,
    HOURS = 2,
    DAYS = 3,
    WEEK = 4,
    MONTH = 5,
    DAYOFTHEWEEK = 6
}

export const REPORT_CALL_BY_INTERVAL_ONE_HOUR_VALUE: string = '1'
export const REPORT_CALL_BY_INTERVAL_TWO_HOURS_VALUE: string = '2'
export const DEFAULT_ENTITY_TYPE_ID: number = 20

export const ENTITY_TYPES = {
    DEVICES_EXTENSIONS_AA: 20,
    AGENTS: 200,
    GROUPS_QUEUES: 43,
    DNIS: 110
}
